import { IViolation, PartDesignItemStructure } from 'src/app/models';

export abstract class PartDesignAcceptedInTeamcenterValidation {
  public static validate(partDesign?: PartDesignItemStructure): IViolation[] {
    if (partDesign) {
      const acceptedRevision = partDesign.revisions.find(
        (revision) => revision.releaseStatus === 'LE4_PartDesignAccepted'
      );

      if (acceptedRevision) {
        return [];
      }
    }

    return [
      {
        message: `Part design has not been accepted in Teamcenter (no baseline with status 'LE4_PartDesignAccepted').`,
        pathToViolation: [],
      },
    ];
  }
}
